var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getValidAccessToken, refreshAccessToken } from './tokenService';
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_FEEDBACK_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});
// Authenticate every backend call with the user's Entra access token (no shared secret).
axiosInstance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    const token = yield getValidAccessToken();
    if (token) {
        config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
}));
// On 401, refresh the token once and retry.
axiosInstance.interceptors.response.use((response) => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const original = error.config;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && original && !original._retried) {
        original._retried = true;
        const token = yield refreshAccessToken();
        if (token) {
            original.headers.set('Authorization', `Bearer ${token}`);
            return axiosInstance(original);
        }
    }
    return Promise.reject(error);
}));
export default axiosInstance;
